import { Injectable } from '@angular/core';
import { ApplicationHostTypeService } from 'rome-library';
import { Observable, Subject } from 'rxjs';

import { TokenStore } from './token.store';

@Injectable({
  providedIn: 'root'
})
export class PopUpService {
  private static readonly Questionmark = '?';
  private static readonly Ampersand = '&';

  private readonly popupBlocked = new Subject();

  constructor(
    private readonly applicationHostTypeService: ApplicationHostTypeService,
    private readonly tokenStore: TokenStore
  ) {}

  public openPopUp(url: string, target?: string): void {
    const querySeparatorPrefix = this.getQueryParamSeparator(url);
    const popUpUrl = url.concat(`${querySeparatorPrefix}host=${this.applicationHostTypeService.getHash()}`);
    const popUpWindow = window.open(popUpUrl, target);

    this.fireEventWhenPopUpBlocked(popUpWindow);
  }

  public openPopUpWithAccessToken(url: string, target?: string): void {
    const accessToken = this.tokenStore.getUserContext().AccessToken;
    const urlWithAccessToken = url.concat(`&access_token=${accessToken}`);

    this.openPopUp(urlWithAccessToken, target);
  }

  public openContentPopUp(url: string, target?: string): void {
    const popUpWindow = window.open(url, target);

    this.fireEventWhenPopUpBlocked(popUpWindow);
  }

  public openEmptyPopUp(): Window {
    const popUpWindow = window.open();

    this.fireEventWhenPopUpBlocked(popUpWindow);

    return popUpWindow;
  }

  public popupBlockedObservable(): Observable<Object> {
    return this.popupBlocked.asObservable();
  }

  private fireEventWhenPopUpBlocked(popUpWindow: Window): void {
    if (!popUpWindow || popUpWindow.closed || typeof popUpWindow.closed === 'undefined') {
      this.popupBlocked.next();
    }
  }

  private getQueryParamSeparator(url: string): string {
    return url.indexOf(PopUpService.Questionmark) < 0 ? PopUpService.Questionmark : PopUpService.Ampersand;
  }
}
